/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 10:27:54
 * @LastEditTime: 2022-06-06 16:15:33
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportSubscription/ReportSubscriptionDetail/Reports/index.tsx
 */
import { Label } from '@/src/components/Antd';
import { searchReport } from '@/src/request/analytics/report';
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import { Form, Spin } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import SelectWithDelete from '../../Components/SelectWithDelete';
import css from '../css.module.less';

const Reports = ({ disabled }: { disabled?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data = [], loading } = useRequest(() => searchReport({ input: '' }));
  const optionsList = data.map((item) => ({
    label: item.name,
    value: item.uuid,
  }));
  const calculateReports = (current, index) => {
    return optionsList.filter(
      (x: any) =>
        !(current || []).includes(x.value) || x.value == (current || [])[index],
    );
  };

  return (
    <Spin spinning={loading}>
      <SectionWrapper
        containerClassName={css.sectionContainer}
        titleClassName={css.titleClassName}
        title={getI18n('general.sider.reports')}>
        <Form.List name='reportUuids'>
          {(fields, { add, move, remove }) => (
            <Fragment>
              {fields.map((_, index) => (
                <Form.Item
                  noStyle
                  key={index}
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues.reportUuids !== curValues.reportUuids
                  }>
                  {({ getFieldValue }: any) => (
                    <Form.Item
                      label={
                        <Label
                          title={replaceI18nVariables(
                            getI18n(
                              `reports.reportdetailcomponents.configDrawer.report_text`,
                            ),
                            index + 1,
                          )}
                        />
                      }
                      labelCol={{ span: 24 }}
                      className={css.reportUuid}
                      rules={[
                        {
                          required: true,
                          message: replaceI18nVariables(
                            getI18n(
                              `reportSubscription.reportSubscriptionDetail.reports.report_required`,
                            ),
                            index + 1,
                          ),
                        },
                      ]}
                      name={[fields[index].name]}>
                      <SelectWithDelete
                        optionsList={calculateReports(
                          getFieldValue('reportUuids'),
                          index,
                        )}
                        onDelete={() => remove(index)}
                        disabled={disabled}
                        disabledDelete={fields.length === 1 || disabled}
                      />
                    </Form.Item>
                  )}
                </Form.Item>
              ))}
              {fields.length <= 10 && !disabled && (
                <div className={css.addReport} onClick={() => add('')}>
                  <Icon className={css.addReportIcon} type='iconplus' />
                  {getI18n(
                    'reportSubscription.reportSubscriptionDetail.reports.addreport',
                  )}
                </div>
              )}
            </Fragment>
          )}
        </Form.List>
      </SectionWrapper>
    </Spin>
  );
};

export default Reports;
